<template>
  <div>
    <el-form-item prop="invoice"></el-form-item>

    <div class="col-12 sector invoice-sector px-3">
      <div class="row">
        <div class="sector__header">{{ t("invoices.title") }}</div>
        <div class="sector__content">
          <div class="row">
            <div class="col-12">
              <el-form-item :label="t('invoices.type')" prop="invoice_type" required>
                <el-radio-group v-model="form.invoice_type" size="large" class="mb-3">
                  <el-radio-button v-if="enableEInvoice" label="invoice"> {{ t("invoices.eturnkey") }} </el-radio-button>
                  <el-radio-button v-else label="invoice"> {{ t("invoices.personal") }} </el-radio-button>
                  <el-radio-button label="invoice_paper"> {{ t("invoices.company") }} </el-radio-button>
                  <el-radio-button label="donate"> {{ t("invoices.donation") }} </el-radio-button>
                </el-radio-group>
              </el-form-item>

              <!-- 個人電子發票 -->
              <div v-if="enableEInvoice && form.invoice_type == 'invoice'" class="row">
                <div class="col-12 mb-2">
                  <el-radio-group v-model="form.invoice_relation_option" size="large">
                    <el-radio-button label="ORDER"> {{ t("invoices.member") }} </el-radio-button>
                    <el-radio-button label="MOBILE"> {{ t("invoices.mobile") }} </el-radio-button>
                    <el-radio-button label="MOICA"> {{ t("invoices.moica") }} </el-radio-button>
                    <!-- <el-radio-button label="PAPER"> {{ t("invoices.requestPaper") }} </el-radio-button> -->
                  </el-radio-group>
                </div>

                <div class="col-12" v-if="form.invoice_relation_option == 'MOBILE'">
                  <el-form-item :label="t('invoices.mobileCode')" prop="invoice_relation_value">
                    <el-input
                      v-model="form.invoice_relation_value"
                      :placeholder="t('errors.pleaseInput', [t('invoices.mobileCode')])"
                      size="large"
                      maxlength="50"
                    />
                  </el-form-item>
                </div>

                <div class="col-12" v-else-if="form.invoice_relation_option == 'MOICA'">
                  <el-form-item :label="t('invoices.moicaCode')" prop="invoice_relation_value">
                    <el-input
                      v-model="form.invoice_relation_value"
                      :placeholder="t('errors.pleaseInput', [t('invoices.moicaCode')])"
                      size="large"
                      maxlength="50"
                    />
                  </el-form-item>
                </div>

              </div>

              <!-- 公司戶電子發票 -->
              <div class="row" v-if="form.invoice_type == 'invoice_paper'">
                <div class="col-12 col-md-4">
                  <el-form-item :label="t('invoices.uniformNumbers')" prop="invoice_paper_no">
                    <el-input v-model="form.invoice_paper_no" :placeholder="t('carts.required')" size="large" maxlength="10" />
                  </el-form-item>
                </div>

                <div class="col-12 col-md-4">
                  <el-form-item :label="t('invoices.companyName')" prop="invoice_paper_title">
                    <el-input v-model="form.invoice_paper_title" :placeholder="t('carts.required')" size="large" maxlength="100" />
                  </el-form-item>
                </div>

                <div v-if="enableEInvoice" class="col-12 col-md-4">
                  <el-form-item :label="t('invoices.mobile')" prop="invoice_paper_relation_mobile">
                    <el-input v-model="form.invoice_paper_relation_mobile" :placeholder="t('carts.optional')" size="large" maxlength="20" />
                  </el-form-item>
                </div>

              </div>

              <!-- 捐贈 -->
              <div class="w-100" v-if="form.invoice_type == 'donate'">
                <el-form-item label="" :label-width="0" prop="invoice_donate_code">
                  <el-select v-model="form.invoice_donate_code" size="large" style="width: 100%;">
                    <el-option
                      v-for="item in state.invoiceDonateOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </div>

              <!-- 紙本發票地址 -->
              <el-form-item
                v-if="!sameHome && ((form.invoice_type == 'invoice' && form.invoice_relation_option == 'PAPER') || form.invoice_type == 'invoice_paper')"
                required
                :label="t('invoices.address')"
              >
                <el-row :gutter="10" style="width: 100%;">
                  <el-col :xs="24" :sm="12" :md="6" class="address-select mb-3">
                    <el-form-item prop="invoice_province">
                      <el-select
                        v-model="form.invoice_province"
                        :disabled="Object.keys(proviceMap).length <= 0"
                        :placeholder="`---${t('users.province')}---`"
                        size="large"
                        style="width: 100%;"
                      >
                        <el-option
                          v-for="(obj, code) in proviceMap"
                          :key="code"
                          :label="obj.name + '(' + obj.name_en + ')'"
                          :value="code"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>

                  <el-col v-if="!!Object.keys(invoiceCityMap).length" :xs="24" :sm="12" :md="6" class="address-select mb-3">
                    <el-form-item prop="invoice_city">
                      <el-select
                        v-model="form.invoice_city"
                        :disabled="Object.keys(invoiceCityMap).length <= 0"
                        :placeholder="`---${t('users.city')}---`"
                        size="large"
                        style="width: 100%;"
                      >
                        <el-option
                          v-for="(obj, code) in invoiceCityMap"
                          :key="code"
                          :label="obj.name + '(' + obj.name_en + ')'"
                          :value="code"
                          :disabled="isTwOuterIslands(code)"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>

                  <el-col v-if="!!Object.keys(invoiceRegionMap).length" :xs="24" :sm="12" :md="6" class="address-select mb-3">
                    <el-form-item prop="invoice_region">
                      <el-select
                        v-model="form.invoice_region"
                        :disabled="Object.keys(invoiceRegionMap).length <= 0"
                        :placeholder="`---${t('users.region')}---`"
                        size="large"
                        style="width: 100%;"
                      >
                        <el-option
                          v-for="(obj, code) in invoiceRegionMap"
                          :key="code"
                          :label="obj.name + '(' + obj.name_en + ')'"
                          :value="code"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>

                  <el-col :xs="24" :sm="12" :md="6" class="address-select mb-3">
                    <el-form-item prop="invoice_postal_code">
                      <el-input v-model="form.invoice_postal_code" :placeholder="t('users.postcode')" size="large" maxlength="20" />
                    </el-form-item>
                  </el-col>

                  <el-col :span="24" class="address-select mb-3">
                    <el-form-item prop="invoice_address">
                      <el-input
                        v-model="form.invoice_address"
                        :placeholder="t('errors.pleaseInput', [t('invoices.address')])"
                        size="large"
                        maxlength="100"
                        show-word-limit
                      />
                    </el-form-item>
                  </el-col>

                </el-row>
              </el-form-item>

              <div v-if="hasHome && showAddress">
                <el-checkbox v-model="sameHome" @change="handleSameHome">
                  {{ t('carts.sameAsBuyer') }}
                </el-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { watch, ref, computed } from 'vue'
import { useI18n } from "vue-i18n"
import { useVModel } from '@vueuse/core'

const props = defineProps({
  modelValue: Object,
  state: Object,
  proviceMap: Object,
  usedLogisticTypes: Array,
  enableEInvoice: {
    type: Boolean,
    default: false,
  },
})
const emit = defineEmits(['update:modelValue', 'change'])

const { t, locale } = useI18n()
const form = useVModel(props, 'modelValue', emit)

// 啟用電子發票
const enableEInvoice = ref(props.enableEInvoice)
if (enableEInvoice.value) {
  form.value.invoice_relation_option = "ORDER"
}
// 與宅配地址相同
const sameHome = ref(true)

const twOuterIslands = ["ILA.DYI","KHH.DSA","KHH.NSA","PEN.MGG","PEN.WAN","PEN.QMI","PEN.BSA","PEN.HXI","PEN.XYU","KMN.LYU","KMN.WQU","KMN.JCG","KMN.JHU","KMN.JNG","KMN.JSA","TTT.LDO","TTT.LYU","PIF.LQU","LCG.BGN","LCG.DYN","LCG.JGG","LCG.NGN"]

const isTwOuterIslands = (city) => {
  // if (form.value.country != 'TW') {
  //   return false
  // }
  // const k = form.value.invoice_province + "." + city
  // if (twOuterIslands.includes(k)) {
  //   return true
  // }
  return false
}

const hasHome = computed(() => {
  const logistic_types = ['TCAT', 'PERSONALLY', 'MUNETEX'];
  const target = props.usedLogisticTypes.find(t => {
      return logistic_types.includes(t);
  })
  return !!target;
});

const showAddress = computed(() => {
  if (form.value.invoice_type == "invoice" && enableEInvoice.value) {
    return false
  }
  else if (form.value.invoice_type == "donate") {
    return false
  }
  return true
})
const invoiceCityMap = computed(() => {
  if (form.value.invoice_province) {
    const province_info = props.proviceMap[form.value.invoice_province];
    const postal_code = province_info.postal;
    form.value.invoice_city = null
    form.value.invoice_postal_code = postal_code ? postal_code : null
    return province_info.city || {};
  }
  return {};
});

const invoiceRegionMap = computed(() => {
  if (form.value.invoice_city) {
    const city_info = invoiceCityMap.value[form.value.invoice_city]
    const postal_code = city_info.postal
    if (postal_code) {
      form.value.invoice_postal_code = postal_code
    }
    return city_info.region || {}
  }
  return {}
});

const handleSameHome = (val) => {
  emit("change", val)
  form.value.invoice_postal_code = form.value.postal_code
  form.value.invoice_province = form.value.province
  form.value.invoice_region = form.value.region
  form.value.invoice_city = form.value.city
  form.value.invoice_address = form.value.address
}

watch(
  () => hasHome.value,
  (val) => {
    if (!val) {
      sameHome.value = val
      handleSameHome(sameHome.value)
    }
  },
  { deep: false, immediate: true }
)
</script>
